import Cloudinary from './Cloudinary';
import S3 from './S3';

const getStrategy = (mimeType: any, fileName: any, size: any) => {
  if (mimeType.indexOf('image') >= 0) {
    return Cloudinary;
  } else {
    return S3;
  }
};

export default {
  getStrategy: getStrategy,
};
